import * as React from 'react';

import { ProgressBar } from '../../components/ProgressBar';
import { formContextObj } from '../FormContainer/context';

export const ProgressBarContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { currentStepCount, maxStepsCount } = React.useContext(formContextObj);

  return <ProgressBar currentStepCount={currentStepCount} maxStepsCount={maxStepsCount} />;
};

ProgressBarContainer.displayName = 'ProgressBarContainer';
